import { createFileRoute, useParams } from '@tanstack/react-router';

import { useMyProgress } from '@/api/me/class-progress.ts';
import { EmptyState } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { MyProgressView } from '@/views/courses/detail/my-progress-view.tsx';

// 学生课程内自我进度视图（服务器将成绩门控在反馈发布 +
// mastery releasedOnly 之后）。
export const Route = createFileRoute('/_learner/courses_/$id/my-progress')({
  component: MyProgressTab,
});

function MyProgressTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/my-progress' });
  const user = useAuth((s) => s.user);
  const dataQ = useMyProgress(id);

  if (!user) return null;
  if (dataQ.isPending) return <MyProgressSkeleton />;
  if (dataQ.isError || !dataQ.data) {
    return <EmptyState>Could not load your progress for this course.</EmptyState>;
  }
  return <MyProgressView data={dataQ.data} />;
}

function MyProgressSkeleton() {
  return (
    <div className="space-y-6" aria-hidden>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-20 animate-pulse rounded-xl bg-neutral-100" />
        ))}
      </div>
      <div className="h-48 w-full animate-pulse rounded-md bg-neutral-100" />
    </div>
  );
}
